import { getEnv } from '@luna/env';

import { clientOptionsFactory } from './profile/clientOptions';

clientOptionsFactory.set(() => ({ baseUrl: `${getEnv().apiGatewayUrl}dashboard` }));
